(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-carrusel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-carrusel')) {
    class BannerCarrusel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.banner-carrusel__track');
        this.slides = [...this.querySelectorAll('.banner-carrusel__slide')];
        this.dots = [...this.querySelectorAll('.banner-carrusel__dot')];
        this.current = 0;
        if (!this.track || this.slides.length < 2) return;

        this.querySelectorAll('.banner-carrusel__arrow').forEach((btn) =>
          btn.addEventListener('click', () => this.go(this.current + Number(btn.dataset.dir), true))
        );
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go), true)));

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(Number(entry.target.dataset.index));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Number(this.dataset.interval) || 5000;
        ['mouseenter', 'touchstart', 'focusin'].forEach((ev) =>
          this.addEventListener(ev, () => this.stop(), { passive: true })
        );
        ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => this.start()));
        this.start();

        this.onBlockSelect = (event) => {
          const index = this.slides.findIndex((s) => s.id === `Banner-${event.detail.blockId}`);
          if (index > -1) {
            this.stop();
            this.go(index);
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      go(index, userAction = false) {
        const total = this.slides.length;
        const target = (index + total) % total;
        this.track.scrollTo({ left: this.slides[target].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.setActive(target);
        if (userAction) this.restart();
      }

      setActive(index) {
        this.current = index;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      }

      start() {
        if (!this.autoplay || this.timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.go(this.current + 1), this.interval);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('banner-carrusel', BannerCarrusel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beneficios-carrusel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('beneficios-carrusel')) {
    class BeneficiosCarrusel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.beneficios-carrusel__track');
        this.slides = [...this.querySelectorAll('.beneficios-carrusel__slide')];
        this.arrows = this.querySelector('.beneficios-carrusel__arrows');
        this.dotsWrap = this.querySelector('.beneficios-carrusel__dots');
        if (!this.track || !this.slides.length) return;

        this.current = 0;
        this.pages = 1;
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Number(this.dataset.interval) || 4000;

        this.querySelectorAll('.beneficios-carrusel__arrow').forEach((btn) =>
          btn.addEventListener('click', () => this.go(this.current + Number(btn.dataset.dir), true))
        );
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        ['mouseenter', 'touchstart', 'focusin'].forEach((ev) =>
          this.addEventListener(ev, () => this.stop(), { passive: true })
        );
        ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => this.start()));

        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(this.track);

        // Anima la entrada la primera vez que la sección aparece en pantalla.
        if (this.classList.contains('beneficios-carrusel--animate')) {
          if (window.Shopify?.designMode) {
            this.classList.add('is-visible');
          } else {
            this.revealObserver = new IntersectionObserver(
              (entries) => {
                if (entries.some((e) => e.isIntersecting)) {
                  this.classList.add('is-visible');
                  this.revealObserver.disconnect();
                }
              },
              { threshold: 0.2 }
            );
            this.revealObserver.observe(this);
          }
        }

        this.onBlockSelect = (event) => {
          const index = this.slides.findIndex((s) => s.id === `Beneficio-${event.detail.blockId}`);
          if (index > -1) {
            this.stop();
            this.go(Math.min(index, this.pages - 1));
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.stop();
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      // Cuántas posiciones distintas hay para deslizar según lo que cabe en pantalla.
      layout() {
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const style = getComputedStyle(this.track);
        const inner = this.track.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const visible = Math.max(1, Math.floor((inner + gap + 1) / (slideWidth + gap)));
        this.pages = Math.max(1, this.slides.length - visible + 1);
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.arrows.hidden = !overflow;
        this.dotsWrap.hidden = !overflow;
        this.dotsWrap.innerHTML = '';
        this.dots = [...Array(this.pages)].map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'beneficios-carrusel__dot';
          dot.setAttribute('aria-label', `Ir al beneficio ${i + 1}`);
          dot.addEventListener('click', () => this.go(i, true));
          this.dotsWrap.appendChild(dot);
          return dot;
        });
        this.setActive(Math.min(this.current, this.pages - 1));
        overflow ? this.start() : this.stop();
      }

      onScroll() {
        const left = this.track.scrollLeft;
        const maxLeft = this.track.scrollWidth - this.track.clientWidth;
        let index = 0;
        this.slides.forEach((s, i) => {
          if (Math.abs(this.offsetOf(s) - left) < Math.abs(this.offsetOf(this.slides[index]) - left)) index = i;
        });
        if (left >= maxLeft - 2) index = this.pages - 1;
        this.setActive(Math.min(index, this.pages - 1));
      }

      offsetOf(slide) {
        return slide.offsetLeft - this.track.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft);
      }

      go(index, userAction = false) {
        const target = ((index % this.pages) + this.pages) % this.pages;
        this.track.scrollTo({ left: this.offsetOf(this.slides[target]), behavior: 'smooth' });
        this.setActive(target);
        if (userAction) this.restart();
      }

      setActive(index) {
        this.current = index;
        this.dots?.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      }

      start() {
        if (!this.autoplay || this.timer || this.pages < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.go(this.current + 1), this.interval);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('beneficios-carrusel', BeneficiosCarrusel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categorias-franja"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('categorias-franja')) {
    customElements.define(
      'categorias-franja',
      class CategoriasFranja extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.categorias-franja__track');
          this.arrows = this.querySelectorAll('.categorias-franja__arrow');
          if (!this.track || !this.arrows.length) return;

          this.arrows.forEach((arrow) =>
            arrow.addEventListener('click', () => {
              const item = this.track.querySelector('.categorias-franja__item');
              const step = item ? item.getBoundingClientRect().width : this.track.clientWidth;
              this.track.scrollBy({ left: step * Number(arrow.dataset.dir), behavior: 'smooth' });
            })
          );

          this.update = this.update.bind(this);
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.track?.removeEventListener('scroll', this.update);
        }

        // Las flechas solo aparecen si hay más categorías de las que caben
        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const overflow = max > 2;
          this.arrows.forEach((arrow) => {
            arrow.hidden = !overflow;
            const dir = Number(arrow.dataset.dir);
            arrow.disabled = dir < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max - 2;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapa-sucursales"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mapa-sucursales')) {
    const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const parseRange = (value) => {
      const m = /^(\d{1,2})(?::(\d{2}))?-(\d{1,2})(?::(\d{2}))?$/.exec(value || '');
      if (!m) return null;
      return [Number(m[1]) * 60 + Number(m[2] || 0), Number(m[3]) * 60 + Number(m[4] || 0)];
    };
    const formatTime = (minutes) => `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
    const DAY_NAMES = ['el domingo', 'el lunes', 'el martes', 'el miércoles', 'el jueves', 'el viernes', 'el sábado'];

    class MapaSucursales extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.W = Number(d.w);
        this.H = Number(d.h);
        this.geo = { kx: Number(d.kx), k: Number(d.k), lonL: Number(d.lonl), latTop: Number(d.lattop) };
        this.mini = {
          w: Number(d.mw),
          h: Number(d.mh),
          kx: Number(d.mkx),
          k: Number(d.mk),
          lonL: Number(d.mlonl),
          latTop: Number(d.mlattop),
        };

        this.viewport = this.querySelector('.mapa-suc__viewport');
        this.world = this.querySelector('.mapa-suc__world');
        this.svg = this.querySelector('.mapa-suc__svg');
        this.highlight = this.querySelector('.mapa-suc__region-hl');
        this.frame = this.querySelector('.mapa-suc__mini-frame');
        this.list = this.querySelector('.mapa-suc__list');
        this.items = [...this.querySelectorAll('.mapa-suc__item')];
        this.pins = [...this.querySelectorAll('.mapa-suc__pin')];
        this.regions = [...this.querySelectorAll('.mapa-suc__region')];
        this.cardsQuery = window.matchMedia('(max-width: 989px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.viewport || !this.world || !this.list) return;

        this.view = null;
        this.focused = false;
        this.active = -1;
        this.pinByIndex = new Map(this.pins.map((pin) => [Number(pin.dataset.index), pin]));

        // Aparecen de norte a sur.
        [...this.pins]
          .sort((a, b) => Number(a.dataset.y) - Number(b.dataset.y))
          .forEach((pin, i) => pin.style.setProperty('--d', i));

        this.pins.forEach((pin) => {
          pin.region = this.findRegion(Number(pin.dataset.x), Number(pin.dataset.y));
          pin.addEventListener('click', () => this.select(Number(pin.dataset.index), true));
        });

        this.items.forEach((item, i) => {
          item.querySelector('.mapa-suc__item-head')?.addEventListener('click', () => this.select(i, true));
          if (window.matchMedia('(hover: hover)').matches) {
            item.addEventListener('mouseenter', () => {
              const pin = this.pinByIndex.get(i);
              this.hovered = pin?.mergedInto || pin;
              this.hovered?.classList.add('is-hover');
            });
            item.addEventListener('mouseleave', () => {
              this.hovered?.classList.remove('is-hover');
              this.hovered = null;
            });
          }
        });

        this.querySelector('.mapa-suc__reset')?.addEventListener('click', () => this.showAll());

        this.list.addEventListener(
          'scroll',
          () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => this.onCardsScroll(), 120);
          },
          { passive: true }
        );

        this.onModeChange = () => this.syncExpanded();
        this.cardsQuery.addEventListener?.('change', this.onModeChange);

        this.setActive(0);

        this.resizeObserver = new ResizeObserver(() => this.refit());
        this.resizeObserver.observe(this.viewport);

        this.classList.add('is-armed');
        if (window.Shopify?.designMode || !this.classList.contains('mapa-suc--animate')) {
          this.classList.add('is-revealed');
        } else {
          this.revealObserver = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.classList.add('is-revealed');
                this.revealObserver.disconnect();
              }
            },
            { threshold: 0.2 }
          );
          this.revealObserver.observe(this);
        }

        this.updateStatus();
        this.statusTimer = setInterval(() => this.updateStatus(), 60000);

        this.onBlockSelect = (event) => {
          const i = this.items.findIndex((item) => item.id === `Sucursal-${event.detail.blockId}`);
          if (i > -1) this.select(i, true);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        clearTimeout(this.scrollTimer);
        clearInterval(this.statusTimer);
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
        this.cardsQuery?.removeEventListener?.('change', this.onModeChange);
      }

      /* ---------- selección ---------- */

      select(index, scrollCard = false) {
        this.setActive(index);
        const pin = this.pinByIndex.get(index);
        // La sucursal elegida pasa a ser la visible de su grupo antes del zoom.
        if (this.view) this.applyLayout(this.layoutFor(this.view.s, this.focused, this.view.tx, this.view.ty));
        if (pin) {
          this.focused = true;
          this.classList.add('is-focus');
          this.goTo(this.focusView(pin));
        }
        if (scrollCard && this.cardsQuery.matches) this.scrollToCard(index);
      }

      showAll() {
        this.focused = false;
        this.classList.remove('is-focus');
        this.goTo(this.overviewView());
      }

      setActive(index) {
        if (index === this.active) return;
        this.active = index;
        this.items.forEach((item, i) => item.classList.toggle('is-active', i === index));
        this.pins.forEach((pin) => pin.classList.toggle('is-active', Number(pin.dataset.index) === index));
        this.syncExpanded();

        const pin = this.pinByIndex.get(index);
        const place = this.querySelector('.mapa-suc__place');
        if (place) place.textContent = pin?.region?.dataset.name || '';
        if (pin?.region && this.highlight) {
          this.highlight.setAttribute('d', pin.region.getAttribute('d'));
          this.highlight.classList.remove('is-on');
          void this.highlight.getBoundingClientRect();
          this.highlight.classList.add('is-on');
        } else {
          this.highlight?.classList.remove('is-on');
        }
      }

      syncExpanded() {
        const cards = this.cardsQuery.matches;
        this.items.forEach((item, i) =>
          item
            .querySelector('.mapa-suc__item-head')
            ?.setAttribute('aria-expanded', cards || i === this.active ? 'true' : 'false')
        );
      }

      onCardsScroll() {
        if (!this.cardsQuery.matches) return;
        const listBox = this.list.getBoundingClientRect();
        const pad = parseFloat(getComputedStyle(this.list).paddingLeft) || 0;
        let best = 0;
        let bestDistance = Infinity;
        this.items.forEach((item, i) => {
          const distance = Math.abs(item.getBoundingClientRect().left - listBox.left - pad);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        const atEnd = this.list.scrollLeft > 0 && this.list.scrollLeft >= this.list.scrollWidth - this.list.clientWidth - 2;
        if (atEnd) best = this.items.length - 1;
        if (best !== this.active) this.select(best);
      }

      scrollToCard(index) {
        const item = this.items[index];
        if (!item) return;
        const pad = parseFloat(getComputedStyle(this.list).paddingLeft) || 0;
        const delta = item.getBoundingClientRect().left - this.list.getBoundingClientRect().left - pad;
        this.list.scrollTo({ left: this.list.scrollLeft + delta, behavior: this.reduced ? 'auto' : 'smooth' });
      }

      findRegion(x, y) {
        const hit = (px, py) => {
          let point;
          try {
            point = this.svg.createSVGPoint();
            point.x = px;
            point.y = py;
          } catch (e) {
            point = new DOMPoint(px, py);
          }
          return this.regions.find((region) => {
            try {
              return region.isPointInFill(point);
            } catch (e) {
              return false;
            }
          });
        };
        // Si el pin cae justo en la costa, prueba alrededor.
        const offsets = [[0, 0], [6, 0], [0, 6], [0, -6], [12, 0], [12, 8], [12, -8], [20, 0], [-6, 0]];
        for (const [dx, dy] of offsets) {
          const region = hit(x + dx, y + dy);
          if (region) return region;
        }
        return null;
      }

      /* ---------- encuadre y zoom ---------- */

      size() {
        return { cw: this.viewport.clientWidth, ch: this.viewport.clientHeight };
      }

      clampView(s, cx, cy) {
        const { cw, ch } = this.size();
        s = Math.min(Math.max(s, cw / this.W, ch / this.H), 3.2);
        let tx = cw / 2 - cx * s;
        let ty = ch / 2 - cy * s;
        tx = Math.min(0, Math.max(cw - this.W * s, tx));
        ty = Math.min(0, Math.max(ch - this.H * s, ty));
        return { s, tx, ty };
      }

      // Encuadre con todas las sucursales, sin cortar los nombres.
      overviewView() {
        const { cw, ch } = this.size();
        const pad = 20;
        if (!this.pins.length) return this.clampView(Math.min(cw / 420, ch / 900), 1210, 1450);
        const ys = this.pins.map((pin) => Number(pin.dataset.y));
        const y0 = Math.min(...ys);
        const y1 = Math.max(...ys);
        const fit = Math.min((ch - pad * 2 - 44) / Math.max(y1 - y0, 220), 1.2);
        let s = fit;
        let layout = null;
        let lo = 0;
        let hi = 0;
        for (let i = 0; i < 12; i++) {
          layout = this.layoutFor(s, false);
          const extents = layout.groups.map((group) => {
            const width = (group.lead.querySelector('.mapa-suc__pin-label')?.offsetWidth || 0) + 19;
            const left = layout.left.has(group.lead);
            return { x: Number(group.lead.dataset.x), a: left ? width : 16, b: left ? 16 : width };
          });
          lo = pad - Math.min(...extents.map((p) => p.x * s - p.a));
          hi = cw - pad - Math.max(...extents.map((p) => p.x * s + p.b));
          if (lo <= hi || s <= fit * 0.7) break;
          s = Math.max(s * 0.95, fit * 0.7);
        }
        const tx = (lo + hi) / 2;
        const view = this.clampView(s, (cw / 2 - tx) / s, (y0 + y1) / 2);
        view.layout = layout;
        return view;
      }

      // Zoom a una sucursal: si tiene otra muy cerca, se acerca hasta que queden separadas.
      focusView(pin) {
        const { cw, ch } = this.size();
        const x = Number(pin.dataset.x);
        const y = Number(pin.dataset.y);
        let nearest = Infinity;
        this.pins.forEach((other) => {
          if (other !== pin) nearest = Math.min(nearest, Math.hypot(Number(other.dataset.x) - x, Number(other.dataset.y) - y));
        });
        const base = Math.min(ch / 330, cw / 290, 1.9);
        const apart = Number.isFinite(nearest) && nearest > 0 ? Math.min(36 / nearest, 3.2) : 0;
        const view = this.clampView(Math.max(base, apart, this.overviewView().s * 1.3), x, y);
        view.layout = this.layoutFor(view.s, true, view.tx, view.ty);
        return view;
      }

      // Agrupa los pines que a esta escala quedarían encimados y elige hacia qué lado va cada nombre.
      // Con zoom (tx/ty conocidos) oculta los nombres que quedarían cortados por el borde.
      layoutFor(s, focus, tx = null, ty = null) {
        const { cw, ch } = this.size();
        const activePin = this.pinByIndex.get(this.active);
        const order = [...this.pins].sort((a, b) => {
          if (a === activePin) return -1;
          if (b === activePin) return 1;
          return Number(a.dataset.index) - Number(b.dataset.index);
        });
        const groups = [];
        order.forEach((pin) => {
          const x = Number(pin.dataset.x) * s;
          const y = Number(pin.dataset.y) * s;
          const group = groups.find((g) => Math.hypot(g.x - x, g.y - y) < 30);
          if (group) group.members.push(pin);
          else groups.push({ x, y, lead: pin, members: [pin] });
        });

        const boxes = groups.map((g) => ({
          x: g.x,
          y: g.y,
          w: g.lead.querySelector('.mapa-suc__pin-label')?.offsetWidth || 0,
          h: 28,
          active: g.lead === activePin,
        }));
        const inView = (r) =>
          tx === null || (r[0] + tx >= 8 && r[2] + tx <= cw - 8 && r[1] + ty >= 8 && r[3] + ty <= ch - 8);
        const rect = (b, left) =>
          left ? [b.x - 17 - b.w, b.y - b.h / 2, b.x - 17, b.y + b.h / 2] : [b.x + 17, b.y - b.h / 2, b.x + 17 + b.w, b.y + b.h / 2];
        const dot = (b) => [b.x - 11, b.y - 22, b.x + 22, b.y + 11];
        const overlap = (r1, r2) =>
          Math.max(0, Math.min(r1[2], r2[2]) - Math.max(r1[0], r2[0])) *
          Math.max(0, Math.min(r1[3], r2[3]) - Math.max(r1[1], r2[1]));
        const n = boxes.length;
        const combos = n <= 10 ? 1 << n : 1;
        let bestMask = 0;
        let bestCost = Infinity;
        for (let mask = 0; mask < combos; mask++) {
          const rects = boxes.map((b, i) => (b.w ? rect(b, (mask >> i) & 1) : null));
          let cost = 0;
          for (let i = 0; i < n; i++) {
            if (!rects[i]) continue;
            cost += (mask >> i) & 1;
            if (focus && !inView(rects[i])) cost += boxes[i].active ? 1e6 : 500;
            for (let j = 0; j < n; j++) {
              if (i === j) continue;
              cost += overlap(rects[i], dot(boxes[j])) * 10;
              if (j > i && rects[j]) cost += overlap(rects[i], rects[j]) * 10;
            }
          }
          if (cost < bestCost) {
            bestCost = cost;
            bestMask = mask;
          }
        }
        const left = new Set(groups.filter((_, i) => (bestMask >> i) & 1).map((g) => g.lead));
        const hidden = new Set(
          focus
            ? groups
                .filter((g, i) => !boxes[i].active && boxes[i].w && !inView(rect(boxes[i], (bestMask >> i) & 1)))
                .map((g) => g.lead)
            : []
        );
        return { groups, left, hidden };
      }

      applyLayout(layout) {
        if (!layout) return;
        layout.groups.forEach((group) => {
          group.members.forEach((pin) => {
            const merged = pin !== group.lead;
            pin.classList.toggle('is-merged', merged);
            pin.mergedInto = merged ? group.lead : null;
          });
          const more = group.lead.querySelector('.mapa-suc__pin-more');
          if (more) {
            more.textContent = `+${group.members.length - 1}`;
            more.hidden = group.members.length < 2;
          }
          group.lead.classList.toggle('mapa-suc__pin--left', layout.left.has(group.lead));
          group.lead.classList.toggle('is-label-off', layout.hidden.has(group.lead));
        });
      }

      refit() {
        const { cw, ch } = this.size();
        if (!cw || !ch) return;
        const pin = this.pinByIndex.get(this.active);
        const target = this.focused && pin ? this.focusView(pin) : this.overviewView();
        this.goTo(target, true);
        if (!this.classList.contains('is-ready')) requestAnimationFrame(() => this.classList.add('is-ready'));
      }

      goTo(target, instant = false) {
        cancelAnimationFrame(this.raf);
        this.setFrame(target);
        if (!this.view || instant || this.reduced) {
          this.applyLayout(target.layout);
          this.apply(target);
          return;
        }
        // Al alejar se agrupan antes de que se encimen; al acercar se separan al terminar.
        const zoomingIn = target.s > this.view.s * 1.01;
        if (!zoomingIn) this.applyLayout(target.layout);
        const from = this.view;
        const { cw, ch } = this.size();
        const fromCenter = { x: (cw / 2 - from.tx) / from.s, y: (ch / 2 - from.ty) / from.s };
        const toCenter = { x: (cw / 2 - target.tx) / target.s, y: (ch / 2 - target.ty) / target.s };
        const start = performance.now();
        const duration = 950;
        const step = (now) => {
          const p = Math.min(1, (now - start) / duration);
          const e = easeInOut(p);
          const s = from.s * Math.pow(target.s / from.s, e);
          const cx = fromCenter.x + (toCenter.x - fromCenter.x) * e;
          const cy = fromCenter.y + (toCenter.y - fromCenter.y) * e;
          this.apply({ s, tx: cw / 2 - cx * s, ty: ch / 2 - cy * s });
          if (p < 1) {
            this.raf = requestAnimationFrame(step);
          } else {
            this.apply(target);
            if (zoomingIn) this.applyLayout(target.layout);
          }
        };
        this.raf = requestAnimationFrame(step);
      }

      apply(v) {
        this.view = v;
        this.world.style.transform = `translate(${v.tx}px, ${v.ty}px) scale(${v.s})`;
        this.world.style.setProperty('--inv', (1 / v.s).toFixed(4));
      }

      // Rectángulo rojo del minimapa: lo que se está viendo del mapa grande.
      setFrame(v) {
        if (!this.frame) return;
        const { cw, ch } = this.size();
        const g = this.geo;
        const m = this.mini;
        const x0 = -v.tx / v.s;
        const y0 = -v.ty / v.s;
        const x1 = x0 + cw / v.s;
        const y1 = y0 + ch / v.s;
        const toMiniX = (x) => (((x / g.kx + g.lonL) - m.lonL) * m.kx / m.w) * 100;
        const toMiniY = (y) => ((m.latTop - (g.latTop - y / g.k)) * m.k / m.h) * 100;
        const clamp = (n) => Math.max(0, Math.min(100, n));
        const left = clamp(toMiniX(x0));
        const right = clamp(toMiniX(x1));
        const top = clamp(toMiniY(y0));
        const bottom = clamp(toMiniY(y1));
        this.frame.style.left = `${left}%`;
        this.frame.style.top = `${top}%`;
        this.frame.style.width = `${Math.max(right - left, 8)}%`;
        this.frame.style.height = `${Math.max(bottom - top, 1.5)}%`;
      }

      /* ---------- abierto / cerrado (hora de Chile) ---------- */

      updateStatus() {
        let parts;
        try {
          parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/Santiago',
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23',
          }).formatToParts(new Date());
        } catch (e) {
          return;
        }
        const get = (type) => parts.find((part) => part.type === type)?.value;
        const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
        const now = (Number(get('hour')) % 24) * 60 + Number(get('minute'));
        if (day < 0 || Number.isNaN(now)) return;

        this.items.forEach((item) => {
          const hours = (item.dataset.hours || '').split('|').map(parseRange);
          if (hours.length !== 7) return;
          item
            .querySelectorAll('[data-days]')
            .forEach((row) => row.classList.toggle('is-today', row.dataset.days.split(',').includes(String(day))));

          const status = item.querySelector('[data-status]');
          if (!status || hours.every((h) => !h)) return;
          const today = hours[day];
          const open = Boolean(today && now >= today[0] && now < today[1]);
          let detail = '';
          if (open) {
            detail = `cierra a las ${formatTime(today[1])}`;
          } else if (today && now < today[0]) {
            detail = `abre hoy a las ${formatTime(today[0])}`;
          } else {
            for (let k = 1; k <= 7; k++) {
              const next = hours[(day + k) % 7];
              if (next) {
                detail = `abre ${k === 1 ? 'mañana' : DAY_NAMES[(day + k) % 7]} a las ${formatTime(next[0])}`;
                break;
              }
            }
          }
          status.textContent = open ? 'Abierta ahora' : 'Cerrada';
          if (detail) {
            const span = document.createElement('span');
            span.textContent = `· ${detail}`;
            status.append(' ', span);
          }
          status.classList.toggle('is-open', open);
          status.hidden = false;
        });
      }
    }

    customElements.define('mapa-sucursales', MapaSucursales);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker-horizontal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ticker-horizontal')) {
    class TickerHorizontal extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
        cancelAnimationFrame(this.frame);
        if (this.onBlockSelect) {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }
      }

      init() {
        if (!this.isConnected || this.resizeObserver) return;

        this.track = this.querySelector('.ticker-h__track');
        this.groups = this.track ? Array.from(this.track.children) : [];
        this.template = this.groups[1]?.firstElementChild;
        if (this.groups.length !== 2 || !this.template) return;

        this.mobile = window.matchMedia('(max-width: 749px)');
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        });
        // El visor cambia con la ventana; el grupo, cuando cargan fuentes o imágenes.
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.groups[0]);

        // En el editor: al elegir un bloque, el ticker se detiene al inicio para poder verlo.
        this.onBlockSelect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.setAttribute('data-editing', '');
        };
        this.onBlockDeselect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.removeAttribute('data-editing');
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      update() {
        const [first, second] = this.groups;
        const viewport = this.clientWidth;
        const setWidth = this.template.getBoundingClientRect().width;
        let width = first.getBoundingClientRect().width;
        if (!viewport || !setWidth || !width) return;

        // Cada mitad debe cubrir el visor completo; si no, se vería un hueco al reiniciar el bucle.
        if (width < viewport) {
          const missing = Math.ceil((viewport - width) / setWidth);
          for (let i = 0; i < missing; i++) {
            for (const group of [first, second]) {
              const copy = this.template.cloneNode(true);
              copy.setAttribute('aria-hidden', 'true');
              group.appendChild(copy);
            }
          }
          width = first.getBoundingClientRect().width;
        }

        const speed = Number(this.mobile.matches ? this.dataset.speedMobile : this.dataset.speed) || 60;
        this.style.setProperty('--ticker-duration-js', `${(width / speed).toFixed(2)}s`);
      }
    }

    customElements.define('ticker-horizontal', TickerHorizontal);
  }

  } catch(e) { console.error(e); }
})();
})();
